import { Provider } from 'jotai';
import { BrowserRouter as Router } from 'react-router-dom';


import Footer from 'layout/Footer';
import Header from 'layout/Header';
import AccessibilityMode from 'utils/AccessibilityMode';
import { ErrorBoundariesWithNavigate } from 'utils/ErrorBoundaries';
import { isUsingFirefox } from 'utils/Helpers';

import App from './App';
import DebugObserver from './DebugObserver';

const Main = () => {
  return (
    <div id="main">
      <Provider>
        <Router>
          <ErrorBoundariesWithNavigate>
            <AccessibilityMode />
            <Header />
            <App />
            <Footer />
            {process.env.NODE_ENV === 'development' && !isUsingFirefox() && (
              <DebugObserver />
            )}
          </ErrorBoundariesWithNavigate>
        </Router>
      </Provider>
    </div>
  );
};

export default Main;
